import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BroadcastService, MessageService, UserService } from '..';
import { MsgConstantConfig } from '../config/message.constant.config';
import { PathConfig } from '../config/path.config';
import { AuthService } from '../services/auth-service';
import { ClientDetailService } from '../services/client-detail-service';
import { GlobalErrorHandler } from '../services/error.handler.service';
import { SessionExpiredService } from '../services/session-expired.service';

@Injectable()
export class HttpInterceptorClass implements HttpInterceptor {
  isChangeUserPasswordErrorDisplayed: boolean = false;
  loggedOutPopupRef:any=null;
  isLoginAsClient:boolean=false;
  isServiceUnavailable:boolean = false;
  constructor(
    private globalHandler: GlobalErrorHandler,
    private clientDetailService: ClientDetailService,
    private authService: AuthService,
    private broadCastService: BroadcastService,
    private msgService: MessageService,
    private userService:UserService,
    private sessionExpiredService: SessionExpiredService,
  ) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(tap(
      (response) => {
        if (response instanceof HttpResponse) {

        }
      },
      (error) => {

        const slug = this.clientDetailService.CLIENT_ID;
        const isAuthenticated = this.authService.isAuthenticated();
        const status = error?.status ?? '';
        const url = !isAuthenticated ? `/${slug}` : `/${slug}/home`;
        switch (status) {
          case 404:
            // window.location.href =  `${url}/error-404?fp=${(isAuthenticated ? 'H' : 'F')}`;
            this.msgService.showError(error?.error?.message);
            break;
          case 403:
            window.location.href = `${url}/error-403?fp=${(isAuthenticated ? 'H' : 'F')}`;//for no access page
            break;
          // case 503://for local service unavailabe
          case 0://for dev service unavailabe
            this.isServiceUnavailable = true;
            this.broadCastService.broadcast(MsgConstantConfig.SERVICE_UNAVAILABLE);
            break;
          case 400:
            if(error?.error?.maintenance_mode == "ON") {
                this.isServiceUnavailable = true;
              this.broadCastService.broadcast(MsgConstantConfig.MAINTENANCE);
              if(error?.error?.message) {
                error.error.message = '';
              }
            }
            break;
          case 401:
            this.isLoginAsClient = this.userService.getLoginType(this.clientDetailService?.clientDetail?.slug);
            if (error?.error?.error === "password_expired") {
              if (error?.error?.message && this.isChangeUserPasswordErrorDisplayed == false) {
                this.isChangeUserPasswordErrorDisplayed = true;
                this.msgService.showError(error?.error?.message);
              }


              this.broadCastService.broadcast(MsgConstantConfig.CHANGE_USER_PASSWORD);
            }

            else if (this.authService.isAuthenticated()) {
             if (this.isLoginAsClient) {
                this.sessionExpiredService.showPopup();
              } else {
                this.broadCastService.broadcast(MsgConstantConfig.AUTH_TOKEN_EXPIRED);
              }
            }
            else if (!this.authService.isAuthenticated() && error?.url !== PathConfig.USER_ME && error?.url !== PathConfig.AUTH_LOGIN_LOGOUT && !this.loggedOutPopupRef) {
              if (!this.isLoginAsClient) {
                window.location.reload();// NOT login as client → reload
              } else if (!error?.url?.includes('unread_count') && !error?.url?.includes('loan_details')) {
                this.sessionExpiredService.showPopup();
              }
            }
            else
              break;
        }

        // verify for expired token
        if (this.authService.isAuthenticated() && this.authService.isTokenExpired() && !this.isServiceUnavailable) {
          if (this.isLoginAsClient) {
            this.sessionExpiredService.showPopup();
          } else {
            this.broadCastService.broadcast(MsgConstantConfig.AUTH_TOKEN_EXPIRED);
          }
        }
        //global error handler
        this.globalHandler.logError(error);
        return throwError(error);
      }));
  }

}
